import { all } from 'redux-saga/effects'
import { authSaga } from './auth/saga'
import { doctorSaga } from './doctor/saga'
import { nurseSaga } from './nurse/saga'
import { patientSaga } from './patient/saga'
import { patientAdmissionsSaga } from './patientAdmission/saga'
import { patientAlertConfigurationSaga } from './patientAlertConfiguration/saga'
import { patientPrescriptionSaga } from './patientPrescription/saga'
import { patientSmsLogsSaga } from './patientSmsLogs/saga'
import { recordedDataSaga } from './recordedData/saga'
import { recordedEcgWindowSaga } from './recordedEcgWindow/saga'
import { recordedEcgArrhythmiaWindowSaga } from './recordedEcgArrhythmiaWindow/saga'
import { singlePatientAlertSaga } from './singlePatientAlert/saga'
import { visualizationDataSaga } from './visualizationData/saga'
import { addsDataSaga } from './addsData/saga'

function* rootSaga() {
  yield all([
    ...patientSaga,
    ...doctorSaga,
    ...nurseSaga,
    ...patientAdmissionsSaga,
    ...singlePatientAlertSaga,
    ...patientSmsLogsSaga,
    ...patientPrescriptionSaga,
    ...authSaga,
    ...recordedDataSaga,
    ...patientAlertConfigurationSaga,
    ...recordedEcgWindowSaga,
    ...recordedEcgArrhythmiaWindowSaga,
    ...visualizationDataSaga,
    ...addsDataSaga,
  ])
}

export default rootSaga
